module.exports = __webpack_public_path__ + "img/Group 391.bf63b4f1.png";